import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RoleState {
  bimpfRole: Record<string, string>;
}

const initialState: RoleState = {
  bimpfRole: {},
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRole: (state, action: PayloadAction<Record<string, string>>) => {
      state.bimpfRole = action.payload;
    },
    removeRole: (state) => {
      state.bimpfRole = {};
    },
  },
});

export const { setRole, removeRole } = roleSlice.actions;
export default roleSlice.reducer;
